import { getProfileValues as getValues } from 'utils/profile-stages';
import Component from './component';
import fields from './fields';
import schema from './schema';

export default {
  title: 'Training Courses',
  description: 'Courses undertaken/attended in the last twelve months.',
  component: Component,
  getValues,
  fields,
  schema,
};
